import type { FieldValidationHandler } from '../components/types';
const combineValidators = (...validators: FieldValidationHandler[]): FieldValidationHandler => (value, entity) => {
  const errors = validators.reduce((acc2, validator) => {
    const validationResult = validator(value, entity);
    if (validationResult?.errors?.length > 0) {
      acc2.push(...validationResult.errors);
    }
    return acc2;
  }, []);
  if (errors?.length > 0) return {
    errors
  };
  return {};
};
export default combineValidators;